const themeProperties = {
  fontSizes: {
    subTitleSize: "14px",
    titleSize: "18px",
  },
  fontFamily:
    '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Helvetica, Arial, sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol"',
  primaryColor: "#68B030",
  primaryDarkColor: "#007a49",
  grey: "#e6e6e6",
  darkGrey: "#B2B2B2",
  light: {
    primaryFontColor: "#2f3336",
    dividerColor: "#d5d5d5",
    secondaryColor: "#ecb641",
    backgroundColor: "#fff",
    highlightBackground: "#4d5153",
    light: "#fff",
    dark: "#000",
    dangerColor: "#e74c3c",
    backgroundColorDark: "#F2F2F7",
    disabledFontColor: "#909090",
    secondaryFontColor: "#4d5153",
    secondaryBackgroundColor: "#f8fbf8",
    activeGreenBgTextColor: "#fff",
  },
  dark: {
    primaryFontColor: "#ffffff",
    dividerColor: "#101113",
    secondaryColor: "#ecb641",
    backgroundColor: "#343a40",
    highlightBackground: "#f2f2f2",
    light: "#fff",
    dark: "#000",
    dangerColor: "#00ef00",
    backgroundColorDark: "#101113",
    disabledFontColor: "#686868",
    secondaryFontColor: "#f0ffed",
    secondaryBackgroundColor: "#575957",
    activeGreenBgTextColor: "#f0ffed",
  },
};

export default themeProperties;
